import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://github.com/mtk246',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://www.facebook.com/ec.is.love/',
    label: 'Facebook',
    icon: faFacebookF,
  },
  {
    link: 'https://www.linkedin.com/in/mtk246',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'mailto:minthukyaw454@gmail.com',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
